import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { AddonsPage } from '@/features/service-agreement-addons/addons-page';

/**
 * The tyre add-ons ("Dækydelser"): the same page as the service-agreement add-ons, on the tyre
 * order flow's catalogue. The `addons` feature's endpoints require `pricing:read` / `:write`.
 */
export const Route = createFileRoute('/_app/addons')({
  staticData: { featureKey: 'addons' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, { feature: 'addons', permissions: ['pricing:read'] }),
  component: TyreAddons,
});

function TyreAddons() {
  return <AddonsPage flow="TYRE_ORDER" />;
}
